export type IconSize = '12' | '16' | '20' | '24' | '32' | '36' | '48' | '96';
